import { Drawer, Box, Typography, IconButton } from "@mui/material";
import TeamForm from "./TeamForm";
import { X } from 'lucide-react';

interface TeamDrawerProps {
  open: boolean;
  userId: any
  CustomerList: any
  onClose: () => void;
}

const TeamDrawer = ({ open, onClose,CustomerList,userId }: TeamDrawerProps) => {
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: {
            xs: "95%",   // <= 600px
            sm: 420,
          },
        },
      }}
    >
      {/* Header */}
      <div style={{ backgroundColor: '#F8B71F' }} className="px-3 sm:px-4 md:px-5 py-4 border-b border-gray-200 flex items-center justify-between">
        <h2 className="text-lg font-semibold text-white">{userId ? "Edit Team": "Add Team"}</h2>
        {/* <IconButton size="small" onClick={onClose}>
          <CloseIcon />
        </IconButton> */}

          <button
            onClick={onClose}
            className="p-1 hover:bg-white hover:bg-opacity-20 rounded-lg transition-colors"
          >
            <X className="w-5 h-5 text-white" />
          </button>
      </div>

      {/* Content */}
      <Box sx={{ p: 2 }}>
        <TeamForm  userId={userId} CustomerList={CustomerList} onClose={onClose}/>
      </Box>
    </Drawer>
  );
};

export default TeamDrawer;
